
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

@Component({
    selector: 'session-expired',
    templateUrl: './session-expired.component.html',
    imports: [
    ButtonModule,
    CardModule
]
})

export class SessionExpiredComponent implements OnInit {
    constructor(
        private router: Router
    ) { }

    ngOnInit(): void { }

    redirectToLogin(): void {
        // this.router.navigate(['/app/login']);
    }
}